import { api } from "./api";

export type UploadedAttachment = { uri: string; type: string; originalFileName: string; };

const MAX_FILE_BYTES = 10 * 1024 * 1024;
const TOKEN = process.env.REACT_APP_API_TOKEN || "";

export async function uploadFiles(files: File[]): Promise<UploadedAttachment[]> {
  const out: UploadedAttachment[] = [];

  for (const file of files) {
    if (file.size > MAX_FILE_BYTES) {
      throw new Error(`${file.name}: קובץ גדול מדי (מקסימום 10MB)`);
    }

    const { data: sas } = await api.post("attachments/sas", {
      origName: file.name,
      contentType: file.type || "application/octet-stream",
      'x-client-token': TOKEN,
    });

    const put = await fetch(sas.uploadUrl, {
      method: "PUT",
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream",
      },
      body: file,
    });
    if (!put.ok) throw new Error(`Blob upload failed (${put.status})`);

    await api.post("attachments/finalize", { blobUrl: sas.blobUrl, 'x-client-token': TOKEN });

    const ext = (file.name.split(".").pop() || "").toLowerCase();
    out.push({ uri: sas.blobUrl, type: ext, originalFileName: file.name });
  }

  return out;
}
